import {buildArrowSymbolizer} from './buildArrowSymbolizer.js';
import {buildPieChartSymbolizer} from './buildPieChartSymbolizer.js';
import {default as OpenLayersParser} from './../geostyler.js';

export function getSymbolizer(symbolizers, symbolindex) {

    var thisgeostyle = {};
    thisgeostyle[symbolindex] = {
        symbolizers: [
            {}
        ],
        filter: ['=='],
        Name: symbolizers['aliasname']
            ? symbolizers['aliasname']
            : symbolizers['value']
    };
    if (symbolindex == 'Point') {
        symbolizers['size'] = symbolizers['size']
            ? parseFloat(symbolizers['size'])
            : 1;
        if (symbolizers['defaultColor'] == '0' && symbolizers['kind'] == 'Icon') {
            symbolizers = changeIconColor(symbolizers);
        }
        var default_value = {
            size: 1,
            opacity: 1,
            fillOpacity: 1,
            strokeOpacity: 1,
            strokeWidth: 1.25,
            radius: 5
        };
        var mustBeNumber = [
            'size',
            'opacity',
            'fillOpacity',
            'strokeOpacity',
            'strokeWidth',
            'radius'
        ];
        mustBeNumber.forEach(field => {
            if (isNaN(parseFloat(symbolizers[field]))) {
                symbolizers[field] = default_value[field];
            } else {
                symbolizers[field] = parseFloat(symbolizers[field]);
            }
        });

        if (symbolizers['kind'] == 'Icon') {

            symbolizers['size'] = symbolizers['radius'] * 2;

        } else {

            symbolizers['fillOpacity'] = symbolizers['fillOpacity']
                ? symbolizers['fillOpacity']
                : symbolizers['opacity'];
            symbolizers['opacity'] = 1;

        }
    }

    if (symbolindex == 'Polygon') {
        var hasGr = false;
        if (symbolizers['graphicwellKnownName'] != null) {
            thisgeostyle[symbolindex]['symbolizers'][0]['graphicFill'] = {
                kind: 'Mark'
            };
            hasGr = true;
        }
        $.each(symbolizers, (fieldindex, property) => {
            if (fieldindex.includes('graphic')) {
                var newfieldindex = fieldindex.slice(7);
                if (hasGr) {
                    if (newfieldindex == 'wellKnownName') {
                        property = property
                            ?.toLowerCase();
                    }
                    property = newfieldindex == 'kind' && property == null
                        ? 'Mark'
                        : property;
                    thisgeostyle[symbolindex]['symbolizers'][0]['graphicFill'][newfieldindex] = property;
                }
            } else {
                if (fieldindex == 'field') {
                    thisgeostyle[symbolindex]['filter'][1] = property;
                    thisgeostyle[symbolindex]['field'] = property;
                } else if (fieldindex == 'value') {
                    thisgeostyle[symbolindex]['filter'][2] = property;
                    thisgeostyle[symbolindex]['value'] = property;
                } else if (property != '' && property != 'null' && property != null && fieldindex != 'Id') {
                    thisgeostyle[symbolindex]['symbolizers'][0][fieldindex] = property;
                }
            }

            if (fieldindex == 'dasharray' || fieldindex == 'outlineDasharray') {
                let dash = property;

                if (dash) {
                    if (!Array.isArray(dash)) {

                        // convert "5,10" or "5 10" to array of numbers
                        dash = dash.replace(/\s+/g, ',');

                        const arr = dash
                            .split(',')
                            .map(v => parseInt(v.trim(), 10))
                            .filter(n => !isNaN(n));

                        thisgeostyle[symbolindex]['symbolizers'][0][fieldindex] = arr;
                    }
                }
            }

        });
    } else if (symbolindex == 'Text') {
        symbolizers['fontWeight'] = symbolizers['bold'];
        //symbolizers['fontStyle'] = symbolizers['bold'];
        $.each(symbolizers, (fieldindex, property) => {
            if (fieldindex == 'field') {
                thisgeostyle[symbolindex]['filter'][1] = property;
                //thisgeostyle[symbolindex]['symbolizers'][0]['label'] = '{{' + property + '}}';
                thisgeostyle[symbolindex]['field'] = property;

                thisgeostyle[symbolindex]['symbolizers'][0][fieldindex] = property;
            } else if (fieldindex == 'text') {
                //thisgeostyle[symbolindex]['filter'][1] = property;
                thisgeostyle[symbolindex]['symbolizers'][0]['label'] = '{{' + property + '}}';

                var vals = property;

                vals = vals
                    .replaceAll('[', '{{')
                    .replaceAll(']', '}}');

                thisgeostyle[symbolindex]['symbolizers'][0]['label'] = vals;

                //thisgeostyle[symbolindex]['field'] = property;

                thisgeostyle[symbolindex]['symbolizers'][0][fieldindex] = property;
            } else if (fieldindex == 'value') {
                thisgeostyle[symbolindex]['filter'][2] = property;
                thisgeostyle[symbolindex]['value'] = property;
            } else if (fieldindex == 'offset') {
                if (property) {
                    if (property.includes(',')) {
                        thisgeostyle[symbolindex]['symbolizers'][0][fieldindex] = property.split(',');
                    }
                }
            } else if (fieldindex == 'MaxRes') {

                if (property != null && property != '') {
                    if (thisgeostyle[symbolindex]['scaleDenominator']) {
                        thisgeostyle[symbolindex]['scaleDenominator']['max'] = parseInt(property);
                    } else {
                        thisgeostyle[symbolindex]['scaleDenominator'] = {
                            'max': parseInt(property)
                        };
                    }
                    thisgeostyle[symbolindex]['symbolizers'][0]['MaxRes'] = parseInt(property);
                }
            } else if (fieldindex == 'MinRes') {
                if (property != null && property != '') {
                    if (thisgeostyle[symbolindex]['scaleDenominator']) {
                        thisgeostyle[symbolindex]['scaleDenominator']['min'] = parseInt(property);
                    } else {
                        thisgeostyle[symbolindex]['scaleDenominator'] = {
                            'min': parseInt(property)
                        };
                    }
                    thisgeostyle[symbolindex]['symbolizers'][0]['MinRes'] = parseInt(property);
                }
            } else if (property != 'null' && property != null && fieldindex != 'Id') {
                thisgeostyle[symbolindex]['symbolizers'][0][fieldindex] = property;
            }
        });
        // on or off textrepeat
        // thisgeostyle[symbolindex]['symbolizers'][0]['textrepeat'] = true;
    } else {
        $.each(symbolizers, (fieldindex, property) => {
            if (fieldindex == 'field') {
                thisgeostyle[symbolindex]['filter'][1] = property;
                thisgeostyle[symbolindex]['field'] = property;
            } else if (fieldindex == 'value') {
                thisgeostyle[symbolindex]['filter'][2] = property;
                thisgeostyle[symbolindex]['value'] = property;
            } else if (fieldindex == 'wellKnownName') {
                thisgeostyle[symbolindex]['symbolizers'][0][fieldindex] = property
                    ?.toLowerCase();
            } else if (property != 'null' && property != null && fieldindex != 'Id') {
                thisgeostyle[symbolindex]['symbolizers'][0][fieldindex] = property;
            }

            if (fieldindex == 'dasharray' || fieldindex == 'outlineDasharray') {
                let dash = property;

                if (dash) {
                    if (!Array.isArray(dash)) {

                        // convert "5,10" or "5 10" to array of numbers
                        dash = dash.replace(/\s+/g, ',');

                        const arr = dash
                            .split(',')
                            .map(v => parseInt(v.trim(), 10))
                            .filter(n => !isNaN(n));

                        thisgeostyle[symbolindex]['symbolizers'][0][fieldindex] = arr;
                    }
                }
            }

            // if (fieldindex == 'dashOffset') {
            // thisgeostyle[symbolindex]['symbolizers'][0]['offset'] = property; }

        });
    }
    return thisgeostyle[symbolindex];
}

export function readFromSymbolizer(symbolizers, defoptions) {

    defoptions = defoptions || {};

    if (symbolizers['samevalues'] == true) {

        var rules = [];

        var styles = {},
            defstyle = {};

        $.each(symbolizers, (type, arrays) => {
            if (type.includes('Symbols')) {
                type = type.replace('Symbols', '');
            }
            if (arrays.length > 0 && arrays instanceof Array) {

                if (arrays[0]['isSimple'] == true) {
                    var symbolizer = arrays[0];
                    if (symbolizer['Type'] == 'PieChart') {

                        var piechartstyleobj = {
                            kind: 'PieChart',
                            symbolizers: []
                        };

                        piechartstyleobj.symbolizers = buildPieChartSymbolizer(symbolizer, defoptions);

                        var name = ' - default';

                        if (!styles[name]) {
                            styles[name] = {};
                        }
                        styles[name]['Name'] = name;
                        styles[name][type] = piechartstyleobj;
                    } else {
                        var geostyle = getSymbolizer(symbolizer, type);
                        var name = ' - default';

                        var smo = geostyle['symbolizers'][0];
                        if (!styles[name]) {
                            styles[name] = {};
                        }
                        styles[name]['Name'] = name;
                        styles[name][type] = smo;
                    }
                } else {
                    var values_a = ['&&'];
                    arrays.forEach((symbolizer) => {
                        if (symbolizer.Id != 0) {

                            var geostyle = getSymbolizer(symbolizer, type);
                            var name = geostyle['value'];
                            name = symbolizer.Id;

                            try {

                                function sanitizeForJSON(str) {
                                    if (typeof str !== "string") 
                                        return ""; // Ensure input is a string
                                    return str
                                        .replace(/\\/g, "\\\\") // Escape backslashes
                                        .replace(/"/g, '\\"') // Escape double quotes
                                        .replace(/\n/g, "\\n") // Escape newlines
                                        .replace(/\r/g, "\\r") // Escape carriage returns
                                        .replace(/\t/g, "\\t") // Escape tabs
                                        .replace(/\f/g, "\\f") // Escape form feed
                                        .replace(/\u0008/g, "\\b") // Properly escape backspace
                                        .replace(/[\u0000-\u001F]/g, ""); // Remove other non-printable control characters
                                }

                                var sanitizedname = sanitizeForJSON(geostyle['value']);

                                if (sanitizedname.trim() !== "") {
                                    name = sanitizedname;
                                }

                            } catch (e) {}

                            var aliasname = geostyle['Name'] + ' - ' + geostyle['field'];
                            //hidden FieldName
                            aliasname = geostyle['Name'];

                            var smo = geostyle['symbolizers'][0];
                            if (!styles[name]) {
                                styles[name] = {};
                            }
                            styles[name]['field'] = geostyle['field'];
                            styles[name]['value'] = geostyle['value'];
                            styles[name]['Name'] = aliasname;
                            styles[name][type] = smo;
                            if (symbolizer['field'] != '' && symbolizer['value'] != null) {
                                if (symbolizer['value'].includes('[') && symbolizer['value'].includes(']')) {
                                    try {
                                        var values = JSON.parse(symbolizer['value']);
                                        var values_b = ['||'];
                                        values.forEach((value, ind) => {
                                            values_a.push(['!=', symbolizer['field'], value]);
                                            values_b.push(['!=', symbolizer['field'], value]);
                                        });
                                    } catch (e) {
                                        values_a.push([
                                            '!=', symbolizer['field'], symbolizer['value']
                                        ]);
                                    }
                                } else {
                                    values_a.push([
                                        '!=', symbolizer['field'], symbolizer['value']
                                    ]);
                                }
                            }

                            //values_a.push(['!=', geostyle['field'], geostyle['value']]);
                        } else {
                            var geostyle = getSymbolizer(symbolizer, type);
                            var smo = geostyle['symbolizers'][0];
                            defstyle[type] = smo;
                            defstyle['Name'] = 'other';

                            aliasName = symbolizer['field'];
                            if (symbolizer['aliasname']) {
                                aliasName = symbolizer['aliasname'];
                            }
                        }
                    });
                    defstyle['filter'] = values_a;
                }

            }
        });

        if (defstyle['Point'] || defstyle['Polygon'] || defstyle['Line'] || defstyle['Text']) {
            styles['other_grodan'] = defstyle;
        }

        var geostyler = {
            "name": "",
            "rules": [],
            'showstyle': true
        };

        var thisindex = 0;

        $.each(styles, (ind, style) => {

            var stylename = style['Name']
                ? style['Name']
                : (style['field'] != ''/*&& style['value'] != ''*/)
                    ? style['value']
                    : 'N/A';

            var rule = {
                Name: stylename,
                symbolizers: [],
                visible: true
            };

            if (style['filter']) {
                rule['filter'] = style['filter'];
            } else {
                if (style['field'] != ''/*&& style['value'] != ''*/
                && style['value'] != null) {
                    if (style['value'].includes('[') && style['value'].includes(']')) {
                        try {
                            var values = JSON.parse(style['value']);
                            var values_b = ['||'];
                            values.forEach((value, ind) => {
                                values_b.push(['==', style['field'], value]);
                            });
                            rule['filter'] = values_b;
                        } catch (e) {
                            rule['filter'] = [
                                '==', style['field'], style['value']
                            ];
                        }
                    } else {
                        rule['filter'] = [
                            '==', style['field'], style['value']
                        ];
                    }
                }
            }

            var rulewellknownname = "default";

            if (rule['filter']) {
                rulewellknownname = rule['filter'][1] + '-' + rule['filter'][2];
                rulewellknownname = style['field'] + '-' + style['value'];

            }

            if (style['Point']) {
                var point = style['Point'];

                if (point['kind'] == 'PieChart') {

                    point
                        .symbolizers
                        .forEach((symbol) => {
                            symbol['visible'] = point['visible'];
                            rule
                                .symbolizers
                                .push(symbol);
                        });

                } else {

                    rule
                        .symbolizers
                        .push(point);

                }

            }

            if (style['Polygon']) {
                var polygon = style['Polygon'];

                rule
                    .symbolizers
                    .push(polygon);
            }

            if (style['Line']) {
                var line = style['Line'];

                rule
                    .symbolizers
                    .push(line);

                if (line['arrow']) {

                    var arrowSymbolizer = buildArrowSymbolizer(line, defoptions);

                    rule
                        .symbolizers
                        .push(arrowSymbolizer);

                }

            }

            if (style['Text']) {
                var label = style['Text'];

                rule
                    .symbolizers
                    .push(label);
            }

            var geostyle = {
                "name": "Demo Style",
                "rules": [rule]
            }

            if (style['field'] != ''/*&& style['value'] != ''*/) {
                geostyle[style['value']] = rule;
                geostyle['field'] = style['field'];
            }

            thisindex++;
            rules.push(rule);
        });

        geostyler['rules'] = rules;

        var olStyle = OpenLayersParser.writeStyleNow(geostyler);

        return olStyle;
    } else if (symbolizers['samevalues'] == false) {
        var arr = [];

        var mysomeind = 0;
        $.each(symbolizers, (type, arrays) => {
            if (type.includes('Symbols')) {
                type = type.replace('Symbols', '');
            }
            var fieldname = '';

            if (arrays != null && arrays.length > 0 && arrays instanceof Array) {

                fieldname = arrays[arrays.length - 1]['field'];

                if (arrays[0]) {
                    fieldname = arrays[0]['aliasname']
                        ? arrays[0]['aliasname']
                        : fieldname;
                }

                if (arrays[0]['isSimple'] == true) {

                    var symbolizer = arrays[0];
                    if (symbolizer['Type'] == 'PieChart') {

                        var piechartstyleobj = {
                            kind: 'PieChart',
                            symbolizers: []
                        };

                        piechartstyleobj.symbolizers = buildPieChartSymbolizer(symbolizer, defoptions);

                        arr.push(piechartstyleobj);

                        mysomeind++;
                    } else {
                        var geostyle = getSymbolizer(symbolizer, type);
                        delete geostyle.filter;

                        var smo = geostyle['symbolizers'][0];

                        if (smo['kind'] == 'Line' && smo['arrow']) {
                            var arrowSymbolizer = buildArrowSymbolizer(smo, defoptions);
                            geostyle['symbolizers'].push(arrowSymbolizer);
                        }

                        arr.push(geostyle);

                        mysomeind++;
                    }
                } else {
                    var values_a = ['&&'],
                        defsymbolizer;

                    arrays.forEach(symbolizer => {

                        var rule = {
                            symbolizers: [],
                            visible: true
                        };

                        if (symbolizer['filter']) {
                            rule['filter'] = symbolizer['filter'];
                        } else {
                            if (symbolizer['field'] != ''/*&& symbolizer['value'] != ''*/
                            && symbolizer['value'] != null) {
                                if (symbolizer['value'].includes('[') && symbolizer['value'].includes(']')) {
                                    try {
                                        var values = JSON.parse(symbolizer['value']);
                                        var values_b = ['||'];
                                        values.forEach((value, ind) => {
                                            values_b.push(['==', symbolizer['field'], value]);
                                        });
                                        rule['filter'] = values_b;
                                    } catch (e) {
                                        rule['filter'] = [
                                            '==', symbolizer['field'], symbolizer['value']
                                        ];
                                    }
                                } else {
                                    rule['filter'] = [
                                        '==', symbolizer['field'], symbolizer['value']
                                    ];
                                }
                            }
                        }

                        if (rule['filter']) {
                            rulewellknownname = rule['filter'][1] + '-' + rule['filter'][2];
                            rulewellknownname = symbolizer['field'] + '-' + symbolizer['value'];
                        }

                        if (arrays.length > 1) {
                            if (symbolizer.Id != 0) {
                                if (symbolizer['field'] != '' && symbolizer['value'] != null) {
                                    if (symbolizer['value'].includes('[') && symbolizer['value'].includes(']')) {
                                        try {
                                            var values = JSON.parse(symbolizer['value']);
                                            values.forEach((value, ind) => {
                                                values_a.push(['!=', symbolizer['field'], value]);
                                            });
                                        } catch (e) {
                                            values_a.push([
                                                '!=', symbolizer['field'], symbolizer['value']
                                            ]);
                                        }
                                    } else {
                                        values_a.push([
                                            '!=', symbolizer['field'], symbolizer['value']
                                        ]);
                                    }
                                }

                                if (type == 'Text') {
                                    if (symbolizer['text'] == '') {
                                        //return null;
                                    }
                                }

                                var geostyle = getSymbolizer(symbolizer, type);

                                if (rule['filter']) {
                                    geostyle['filter'] = rule['filter'];
                                }

                                var smo = geostyle['symbolizers'][0];

                                if (smo['kind'] == 'Line' && smo['arrow']) {
                                    var arrowSymbolizer = buildArrowSymbolizer(smo, defoptions);
                                    geostyle['symbolizers'].push(arrowSymbolizer)

                                }

                                arr.push(geostyle);

                                mysomeind++;

                            } else {
                                defsymbolizer = getSymbolizer(symbolizer, type);
                            }
                        } else if (arrays.length == 1) {
                            var geostyle = getSymbolizer(symbolizer, type);

                            var smo = geostyle['symbolizers'][0];

                            if (smo['kind'] == 'Line' && smo['arrow']) {
                                var arrowSymbolizer = buildArrowSymbolizer(smo, defoptions);
                                geostyle['symbolizers'].push(arrowSymbolizer);
                            }

                            arr.push(geostyle);
                            mysomeind++;
                        }
                    });

                    if (values_a.length > 1) {
                        defsymbolizer['filter'] = values_a;
                        defsymbolizer['Name'] = 'other';

                        var smo = defsymbolizer['symbolizers'][0];
                        if (smo['kind'] == 'Line' && smo['arrow']) {
                            var arrowSymbolizer = buildArrowSymbolizer(smo, defoptions);
                            defsymbolizer['symbolizers'].push(arrowSymbolizer);
                        }

                        arr.push(defsymbolizer);
                    }

                }
            }

        });

        var geostyler = {
            "name": "",
            "rules": arr
        };

        var olStyle = OpenLayersParser.writeStyleNow(geostyler);

        return olStyle;
    }

}